import { create } from 'zustand'
import axios from 'axios'

export const API_SLUG = 'Roles'

interface RoleStore {
  data: any[]
  setData: (data: any[]) => void
  getAll: () => Promise<{ success: boolean; data: any }>
  clearState: () => void
}

export const useRoleStore = create<RoleStore>(set => ({
  data: [],
  setData: (data: any[]) => {
    set({ data })
  },
  getAll: async () => {
    return axios
      .get(`/${API_SLUG}`)
      .then(res => {
        set({ data: res.data })
        return { success: true, data: res.data }
      })
      .catch(err => {
        return { success: false, data: err }
      })
  },
  clearState: () => {
    set({ data: [] })
  },
}))
